import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import LoginPage from './pages/LoginPage';
import AdminHomePage from './pages/AdminHomePage';
import StudentHomePage from './pages/StudentHomePage';
import UnitHomePage from './pages/UnitHomePage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/AdminHomePage" element={<AdminHomePage />} />
        <Route path="/StudentHomePage" element={<StudentHomePage />} />
        <Route path="/UnitHomePage" element={<UnitHomePage />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
